const childAct = {
  // 帮助中心首页
  'childAct_子账号管理': {
    cn: '子账号管理',
    en: 'SubAccount Manager',
    kr: ''
  },
  'childAct_子账号管理操作日志': {
    cn: '子账号管理操作日志',
    en: 'SubAccount Manager Operation log',
    kr: ''
  },
  'childAct_子账号ID': { cn: '子账号ID', en: 'Child account ID' },
  'childAct_状态': { cn: '状态', en: 'Status' },
  'childAct_冻结': { cn: '冻结', en: 'Freeze' },
  'childAct_启用': { cn: '启用', en: 'Enable' },
  'childAct_新增': { cn: '新增', en: 'Add' },
  'childAct_编辑': { cn: '编辑', en: 'Edit' },
  'childAct_正常': {
    cn: '正常',
    en: 'normal'
  },
  'childAct_编辑子账号': { cn: '编辑子账号', en: 'Edit child account' },
  'childAct_新增子账号': { cn: '新增子账号', en: 'Add a sub account' },
  'childAct_请输入邮箱号': { cn: '请输入邮箱号', en: 'Please enter your email' },
  'childAct_请输入邮箱': { cn: '请输入邮箱', en: 'Please enter your email' },
  'childAct_权限分配': { cn: '权限分配', en: 'To allocate' },
  'childAct_姓名查询': { cn: '请输入姓名查询', en: 'Please enter name query' },
  'childAct_被操作人姓名查询': { cn: '请输入被操作人姓名查询', en: 'Please enter The person being manipulated name query' },
  'childAct_输入姓名': { cn: '请输入姓名', en: 'Please enter name' },
  'childAct_是否确定冻结该账号？本次操作只冻结该账号在开放平台的使用，若需要冻结该账号在用户中心的使用，请到用户中心操作': { cn: '是否确定冻结该账号？本次操作只冻结该账号在开放平台的使用，若需要冻结该账号在用户中心的使用，请到用户中心操作', en: 'Are you sure to freeze this account? This operation only freeze the account in the use of open platform, if need to freeze the account to use in the center of the user, please go to user center operations' },

  // HelperCatalog
  'helper_layout_query_none': { cn: '查询无结果', en: 'Query no result' },
  'helper_layout_interface_name': { cn: '接口名称', en: 'Interface Name' }
  // 'helper_layout_': { cn: '', en: '' },
}

export default {
  ...childAct
}
